import { Controller } from "@hotwired/stimulus"

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
let scriptLoading = null

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile)

  scriptLoading ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = SCRIPT_SRC
    script.async = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = reject
    document.head.appendChild(script)
  })

  return scriptLoading
}

// Renders the Cloudflare Turnstile widget explicitly, so it also works after Turbo
// replaces the form (e.g. when validation errors are shown).
export default class extends Controller {
  static values = { siteKey: String }

  async connect() {
    const turnstile = await loadTurnstile()
    if (!this.element.isConnected || this.widgetId !== undefined) return

    this.widgetId = turnstile.render(this.element, {
      sitekey: this.siteKeyValue,
      language: "pl",
      theme: "light",
    })
  }

  disconnect() {
    if (this.widgetId !== undefined && window.turnstile) window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }
}
